// UI strings by language. Keys are grouped by screen with a dotted prefix. Add the English string
// first; a key missing from `es` falls back to English (see LanguageContext), never to blank.
const en = {
    // Navigation
    'nav.scan': 'Scan',
    'nav.scanTickets': 'Scan Tickets',
    'nav.tickets': 'Tickets',
    'nav.invoicing': 'Invoicing',
    'nav.invoices': 'Invoices',
    'nav.createInvoice': 'Create Invoice',
    'nav.settlements': 'Settlements',
    'nav.plantInvoice': 'Plant Invoice',
    'nav.fieldTicketInvoice': 'Field Ticket Invoice',
    'nav.weeklyInvoice': 'Weekly Invoice',
    'nav.weeklySummary': 'Weekly Summary',
    'nav.weeklyRecon': 'Weekly Recon',
    'nav.ticketReport': 'Ticket Report',
    'nav.ticketIntake': 'Ticket Intake',
    'nav.fuelExpenses': 'Fuel & Expenses',
    'nav.flatbedInvoice': 'Flatbed Invoice',
    'nav.payroll': 'Payroll',
    'nav.reconciliation': 'Reconciliation',
    'nav.ocrTool': 'OCR Tool',
    'nav.users': 'Users',
    'nav.masters': 'Masters',
    'nav.more': 'More',
    'nav.logout': 'Logout',
    'nav.language': 'Language',
    'nav.drivers': 'Drivers',
    'nav.carriers': 'Carriers',
    'nav.trucks': 'Trucks',
    'nav.plants': 'Plants',
    'nav.subContractors': 'Sub Contractors',
    'nav.rateCards': 'Rate Cards',
    'nav.plantPaymentConfig': 'Plant Payment Config',
    'nav.hauledForRules': 'Hauled For Rules',

    // Scan
    'scan.title': 'Ticket Upload',
    'scan.takePhoto': 'Take a photo',
    'scan.chooseFiles': 'Choose photos or PDF',
    'scan.dropzone': 'Drag & Drop or Click to Upload Tickets',
    'scan.dropzoneHint': '(Multiple images or a multi-page PDF are accepted)',
    'scan.help': 'Drop your tickets here — each is scanned and processed automatically.',
    'scan.phoneHelp': 'Photograph each ticket flat and in good light. It is read automatically.',
    'scan.scanning': 'Scanning…',

    // Shared
    'common.search': 'Search',
    'common.clear': 'Clear',
    'common.cancel': 'Cancel',
    'common.add': 'Add',
    'common.all': 'All',
    'common.loading': 'Loading…',

    // Filters bar
    'filters.startDate': 'Start Date',
    'filters.endDate': 'End Date',
    'filters.subContractor': 'Sub Contractor',
    'filters.truck': 'Truck',
    'filters.plant': 'Plant',
    'filters.dispatcher': 'Dispatcher',
    'filters.carrier': 'Carrier',
    'filters.driver': 'Driver',

    // Tickets
    'tickets.title': 'Tickets',
    'tickets.verifyFlagged': 'Verify flagged ({n})',
    'tickets.reviewAll': 'Review all ({n})',
    'tickets.selectMultiple': 'Select multiple',
    'tickets.export': 'Export',
    'tickets.mergeCustomers': 'Merge customers',
    'tickets.add': 'Add ticket',
    'tickets.moreActions': 'More actions',
    'tickets.loading': 'Loading tickets…',
    'tickets.searchPlaceholder': 'Search tickets, customers…',
    'tickets.type': 'Type:',
    'tickets.filter': 'Filter:',
    'tickets.customer': 'Customer:',
    'tickets.sortBy': 'Sort by:',
    'tickets.tons': 'Tons',
    'tickets.hours': 'Hours',
    'tickets.loads': 'Loads',
    'tickets.count': 'Tickets',
    'tickets.unassigned': '(Unassigned)',
    'tickets.hiddenUnassigned': 'Tickets with no customer hidden by the Customer filter: {n} —',
    'tickets.view': 'View',
    'tickets.selectModeOn': 'Select mode is on. Check the boxes next to tickets you want to act on together.',
    'tickets.exitSelect': 'Exit select mode',
    'tickets.selectedCount': '{n} selected',
    'tickets.bulkSetCustomer': 'Set customer / type',
    'tickets.bulkInvoice': 'Invoice selected',
    'tickets.bulkReviewed': 'Mark reviewed',
    'tickets.bulkDelete': 'Delete selected',
    'tickets.edit': 'Edit',
    'tickets.scan': 'Scan',
    'tickets.viewScan': 'View scanned ticket',
    'tickets.noScan': 'No scan stored',
    'tickets.delete': 'Delete ticket',
    'tickets.markReviewed': 'Mark reviewed',
    'tickets.noRateAdd': 'No rate · Add',
    'tickets.noRateHelp': 'This code has no rate as of the ticket date — it would invoice/pay at $0. Click to add the rate.',
    'tickets.didYouMean': 'Did you mean {code}?',
    'tickets.noTruck': 'No truck',
    'tickets.createTruck': '+ Create this truck',
    'tickets.rowsPerPage': 'Rows per page',
    'tickets.showing': 'Showing {from}–{to} of {total}',
    'tickets.pageOf': 'Page {page} of {pages}',
    'tickets.addTitle': 'Add new ticket',
    'col.date': 'Date',
    'col.ticketNo': 'Ticket #',
    'col.customer': 'Customer',
    'col.qty': 'Qty',
    'col.truck': 'Truck',
    'col.lastUpdated': 'Last updated',
    'col.actions': 'Actions',
    'status.printed': 'Printed',
    'status.pending': 'Pending review',
    'status.verified': 'Verified',
    'status.error': 'Error',
    'status.needsFix': 'Needs fix',
    'status.incomplete': 'Incomplete',
    'status.needsRate': 'Needs rate',
    'field.ticketType': 'Ticket type',
    'field.date': 'Date',
    'field.ticketNo': 'Ticket No',
    'field.truckNo': 'Truck No',
    'field.plant': 'Plant',
    'field.customer': 'Customer',
    'field.tons': 'Ton',
    'field.jobCode': 'Job Code',
    'field.truckType': 'Truck Type',
    'field.billedTo': 'Customer (Billed To)',
    'field.hours': 'Hours',
    'field.loads': 'Loads',
    'field.origin': 'Producer / Origin (optional)',
    'field.destination': 'Destination (optional)',

    // Invoicing
    'inv.title': 'Invoicing',
    'inv.docType': 'Document type',
    'inv.settlement': 'Settlement sheet',
    'inv.zone': 'Zone-rate invoice',
    'inv.settlementHelp': 'One row per ticket on the dispatcher’s own form — what you submit to get paid. Leave Invoice template blank to use each dispatcher’s configured sheet.',
    'inv.zoneHelp': 'Tickets grouped by customer and FS code at the zone rate — what you bill a customer.',
    'inv.generate': 'Generate',
    'inv.preview': 'Preview',
    'inv.pdf': 'PDF',
    'inv.attachScans': 'Attach scanned tickets to the PDF',
    'inv.invoice': 'INVOICE',
    'inv.number': 'INVOICE NUMBER',
    'inv.date': 'DATE',
    'inv.orderFrom': 'ORDER FROM',
    'inv.truck': 'TRUCK',
    'inv.week': 'WEEK',
    'inv.dispatcher': 'DISPATCHER',
    'inv.tickets': 'TICKETS',
    'inv.totalTickets': 'TOTAL TICKETS',
    'inv.gross': 'GROSS',
    'inv.commission': 'COMMISSION',
    'inv.fuel': 'FUEL',
    'inv.rent': 'RENT',
    'inv.net': 'NET',
    'inv.total': 'TOTAL',
    'inv.amountDue': 'AMOUNT DUE',
    'inv.discount': 'DISCOUNT',
    'inv.subTotal': 'SUB TOTAL',
    'inv.grandTotal': 'GRAND TOTAL',
    'inv.blended': 'blended',
    'inv.perTruck': '{n} invoices — one per truck',
    'inv.time': 'TIME',
    'inv.ticketNo': 'TICKET #',
    'inv.pickup': 'PICK UP',
    'inv.delivery': 'DELIVERY',
    'inv.jobCode': 'JOB / CODE',
    'inv.qty': 'QTY',
    'inv.quantity': 'QUANTITY',
    'inv.rate': 'RATE',
    'inv.priceEach': 'PRICE EACH',
    'inv.amount': 'AMOUNT',
    'inv.description': 'DESCRIPTION',
    'inv.createTitle': 'Create Invoice',
    'inv.createPdf': 'Create Invoice PDF',
    'inv.pickCompany': 'Pick a Sub Contractor (or a truck) and press Search to create the invoice.',
    'inv.countSummary': '{inv} invoice(s) · {tickets} ticket(s) total',
    'inv.companyName': 'Company Name',
    'inv.address': 'Address',
    'inv.phone': 'Phone Number',
    'inv.customerName': 'Customer Name',
    'inv.fsCode': 'FS Code',
    'inv.tonnage': 'Tonnage',
    'inv.truckNo': 'Truck#',
    'inv.totalTons': 'Total Tons',
    'inv.zoneRate': 'Zone Rate',
    'inv.less10': 'Less 10%',
    'inv.finalTotal': 'Final Total',
    'inv.settlementsTitle': 'Settlements',
    'inv.invoiceNumber': 'Invoice Number',
    'inv.invoiceDate': 'Invoice Date',
    'inv.defaultsToEnd': 'Defaults to end date',
    'inv.searchPlaceholder': 'Search…',
    'inv.allTrucks': 'All trucks',
    'inv.noTrucksForSub': 'No trucks for this sub-contractor',
    'inv.noTrucks': 'No trucks',
    'inv.trucksHelpSub': "Optional; empty = all this sub-contractor's trucks",
    'inv.trucksHelp': 'Optional; empty = all trucks',
    'inv.allPlants': 'All plants',
    'inv.plantsHelp': 'Optional; empty = all plants',
    'inv.noDispatcher': 'None — generic sheet',
    'inv.dispatchersHelpMulti': 'Each ticket nets its own dispatcher’s %, rent & fuel; the first prints the sheet',
    'inv.dispatchersHelp': 'Optional; prints on their sheet and nets their %, rent & fuel',
    'inv.template': 'Invoice template',
    'inv.templatePlaceholder': "Dispatcher's own sheet",
    'inv.templateHelp': 'Optional; overrides the sheet for this print only',
    'inv.weekNo': 'Week #',
    'inv.weekNoHelp': 'Optional; defaults to ISO week',
    'inv.weekStart': 'Week Start',
    'inv.weekEnd': 'Week End',
    'inv.discountPct': 'Discount %',
    'inv.discountHelp': 'Optional; e.g. 5 for a 5% settlement deduction',

    'nav.billing': 'Billing',

    // Sign-in / sign-up
    'auth.google': 'Continue with Google',
    'auth.googleFailed': 'Google sign-in didn’t work. Please try again.',
    'auth.googleDisabled': 'Google sign-in isn’t switched on yet. Use email and password.',
    'auth.or': 'or',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.passwordHelp': 'At least 6 characters',
    'auth.signIn': 'Sign in',
    'auth.createAccount': 'Create account',
    'auth.signUpTitle': 'Start your free trial',
    'auth.signUpSub': '14 days free. No card needed. Set up in 2 minutes on your phone.',
    'auth.haveAccount': 'Already have an account?',
    'auth.trialLine': 'Scan tickets, invoice and pay drivers — from your phone.',
    'auth.errInUse': 'That email already has an account. Sign in instead.',
    'auth.errWeak': 'Password must be at least 6 characters.',
    'auth.errEmail': 'Enter a valid email address.',
    'auth.errNetwork': 'Unable to connect. Check your connection and try again.',
    'auth.errSignUp': 'Couldn’t create the account. Please try again.',
    'login.headline': 'Back-office automation for haulers & carriers',
    'login.subhead': 'Ticket scanning, invoicing, payroll, and reconciliation - all in one place.',
    'login.feature1': 'AI-powered ticket scan & extraction',
    'login.feature2': 'Sub Contractor & plant invoice generation',
    'login.feature3': 'Weekly driver payroll with FS code breakdown',
    'login.feature4': 'Rate card management & reconciliation',
    'login.title': 'Sign in to your account',
    'login.sub': 'Enter your credentials to access your workspace.',
    'login.passwordPlaceholder': 'Enter your password',
    'login.forgot': 'Forgot password?',
    'login.signingIn': 'Signing in...',
    'login.agree': 'By signing in you agree to our',
    'login.terms': 'Terms of Service',
    'login.and': 'and',
    'login.privacy': 'Privacy Policy',
    'login.newHere': 'New here? Start a free trial',
    'login.emailRequired': 'Email is required',
    'login.passwordRequired': 'Password is required',
    'login.resetSent': 'Password reset email sent.',
    'login.errDisabled': 'Your account has been deactivated. Contact your administrator.',
    'login.errCredentials': 'Incorrect email or password. Please try again.',
    'login.errGeneric': 'Unable to sign in. Please try again.',

    // Onboarding
    'onb.stepOf': 'Step {n} of {total}',
    'onb.welcome': 'Welcome!',
    'onb.pickType': 'What kind of business do you run?',
    'onb.typeOO': 'Owner-operator',
    'onb.typeOODesc': 'I own my truck(s) and haul for a dispatcher or plant',
    'onb.typeDispatcher': 'Dispatcher',
    'onb.typeDispatcherDesc': 'I dispatch subhaulers and invoice plants and customers',
    'onb.typeDryVan': 'Dry van fleet',
    'onb.typeDryVanDesc': 'I run dry van trucks and track loads, driver pay and profit',
    'onb.trialNote': '14-day free trial. No card needed.',
    'onb.aboutYou': 'About your business',
    'onb.company': 'Business name',
    'onb.companyFleet': 'Fleet / business name',
    'onb.firstName': 'Your first name',
    'onb.lastName': 'Your last name (optional)',
    'onb.signedInAs': 'Signed in as {email}',
    'onb.required': 'Required',
    'onb.back': 'Back',
    'onb.startTrial': 'Start free trial',
    'onb.trucksTitle': 'Your trucks',
    'onb.trucksHelp': 'Add each truck, who drives it, and their pay. Tickets are matched to trucks by number.',
    'onb.trucksHelpDryVan': 'Add each truck, who drives it, and their pay as % of the load. You can add more later.',
    'onb.truckN': 'Truck {n}',
    'onb.removeTruck': 'Remove truck',
    'onb.truckNumber': 'Truck number',
    'onb.driverName': 'Driver name (optional)',
    'onb.driverHelp': 'Leave empty if you drive it yourself',
    'onb.driverPay': 'Driver pay',
    'onb.driverPayHelp': '% of what the truck earns',
    'onb.addTruck': 'Add another truck',
    'onb.continue': 'Continue',
    'onb.skip': 'Skip for now',
    'onb.needTruck': 'Add at least one truck number.',
    'onb.badPct': 'Driver pay must be between 0 and 100%.',
    'onb.dupTruck': 'The same truck number is listed twice.',
    'onb.ready': 'You’re all set!',
    'onb.trialStarted': 'Your 14-day free trial has started.',
    'onb.scanNow': 'Photograph a ticket now',
    'onb.scanHint': 'Lay the ticket flat in good light. We read it for you.',
    'onb.later': 'I’ll do it later',
    'onb.goTrucks': 'Go to my trucks',
    'onb.errNetwork': 'No connection. Check your signal and try again.',
    'onb.errGeneric': 'Something went wrong. Please try again.',

    // Billing
    'bill.title': 'Billing',
    'bill.yourAccount': 'Your account',
    'bill.stateActive': 'Active',
    'bill.stateTrial': 'Free trial',
    'bill.stateTrialEnded': 'Trial ended',
    'bill.statePastDue': 'Payment due',
    'bill.stateReadOnly': 'Read-only',
    'bill.trialLeft': '{n} day(s) left in your free trial (ends {date}).',
    'bill.graceLeft': 'Choose a plan within {n} day(s) to keep adding tickets. Your data is safe.',
    'bill.readOnlyHelp': 'You can see everything, but can’t add or change anything until a plan is active. Nothing has been deleted.',
    'bill.plan': 'Plan',
    'bill.plans': 'Plans',
    'bill.perMonth': '/ month',
    'bill.perWeek': '/ week',
    'bill.usagePrice': '{ticket} per ticket, {min} minimum {per}',
    'bill.upToTickets': 'up to {n} tickets',
    'bill.upToTrucks': 'up to {n} trucks',
    'bill.paymentsSoon': 'Online payment (card, Apple Pay, Google Pay, bank) is coming soon. No card is needed during your trial.',
    'bill.samplePrices': 'Sample prices — subject to change.',
    'bill.loadFailed': 'Couldn’t load billing. Please try again.',
    'bill.bannerTrial': 'Free trial: {n} day(s) left. Tap to see plans.',
    'bill.bannerTrialEnded': 'Your free trial has ended. Choose a plan within {n} day(s) to keep adding tickets.',
    'bill.bannerPastDue': 'Payment failed. Update payment within {n} day(s) to keep adding tickets.',
    'bill.bannerReadOnly': 'Your account is read-only. Tap to choose a plan — your data is safe.',
};

const es = {
    'nav.scan': 'Escanear',
    'nav.scanTickets': 'Escanear tickets',
    'nav.tickets': 'Tickets',
    'nav.invoicing': 'Facturación',
    'nav.invoices': 'Facturas',
    'nav.createInvoice': 'Crear factura',
    'nav.settlements': 'Liquidaciones',
    'nav.plantInvoice': 'Factura de planta',
    'nav.fieldTicketInvoice': 'Factura de tickets de campo',
    'nav.weeklyInvoice': 'Factura semanal',
    'nav.weeklySummary': 'Resumen semanal',
    'nav.weeklyRecon': 'Conciliación semanal',
    'nav.ticketReport': 'Reporte de tickets',
    'nav.ticketIntake': 'Recepción de tickets',
    'nav.fuelExpenses': 'Combustible y gastos',
    'nav.flatbedInvoice': 'Factura de plataforma',
    'nav.payroll': 'Nómina',
    'nav.reconciliation': 'Conciliación',
    'nav.ocrTool': 'Herramienta OCR',
    'nav.users': 'Usuarios',
    'nav.masters': 'Catálogos',
    'nav.more': 'Más',
    'nav.logout': 'Cerrar sesión',
    'nav.language': 'Idioma',
    'nav.drivers': 'Choferes',
    'nav.carriers': 'Transportistas',
    'nav.trucks': 'Camiones',
    'nav.plants': 'Plantas',
    'nav.subContractors': 'Subcontratistas',
    'nav.rateCards': 'Tarifas',
    'nav.plantPaymentConfig': 'Config. de pago de planta',
    'nav.hauledForRules': 'Reglas de acarreo',

    'scan.title': 'Subir tickets',
    'scan.takePhoto': 'Tomar foto',
    'scan.chooseFiles': 'Elegir fotos o PDF',
    'scan.dropzone': 'Arrastre o haga clic para subir tickets',
    'scan.dropzoneHint': '(Se aceptan varias imágenes o un PDF de varias páginas)',
    'scan.help': 'Suelte sus tickets aquí — cada uno se escanea y procesa automáticamente.',
    'scan.phoneHelp': 'Fotografíe cada ticket plano y con buena luz. Se lee automáticamente.',
    'scan.scanning': 'Escaneando…',

    'common.search': 'Buscar',
    'common.clear': 'Limpiar',
    'common.cancel': 'Cancelar',
    'common.add': 'Agregar',
    'common.all': 'Todos',
    'common.loading': 'Cargando…',

    'filters.startDate': 'Fecha inicial',
    'filters.endDate': 'Fecha final',
    'filters.subContractor': 'Subcontratista',
    'filters.truck': 'Camión',
    'filters.plant': 'Planta',
    'filters.dispatcher': 'Despachador',
    'filters.carrier': 'Transportista',
    'filters.driver': 'Chofer',

    'tickets.title': 'Tickets',
    'tickets.verifyFlagged': 'Verificar marcados ({n})',
    'tickets.reviewAll': 'Revisar todos ({n})',
    'tickets.selectMultiple': 'Seleccionar varios',
    'tickets.export': 'Exportar',
    'tickets.mergeCustomers': 'Unir clientes',
    'tickets.add': 'Agregar ticket',
    'tickets.moreActions': 'Más acciones',
    'tickets.loading': 'Cargando tickets…',
    'tickets.searchPlaceholder': 'Buscar tickets, clientes…',
    'tickets.type': 'Tipo:',
    'tickets.filter': 'Filtro:',
    'tickets.customer': 'Cliente:',
    'tickets.sortBy': 'Ordenar por:',
    'tickets.tons': 'Toneladas',
    'tickets.hours': 'Horas',
    'tickets.loads': 'Cargas',
    'tickets.count': 'Tickets',
    'tickets.unassigned': '(Sin cliente)',
    'tickets.hiddenUnassigned': 'Tickets sin cliente ocultos por el filtro de cliente: {n} —',
    'tickets.view': 'Ver',
    'tickets.selectModeOn': 'Modo de selección activo. Marque los tickets que quiere procesar juntos.',
    'tickets.exitSelect': 'Salir de selección',
    'tickets.selectedCount': '{n} seleccionados',
    'tickets.bulkSetCustomer': 'Cambiar cliente / tipo',
    'tickets.bulkInvoice': 'Facturar seleccionados',
    'tickets.bulkReviewed': 'Marcar revisados',
    'tickets.bulkDelete': 'Borrar seleccionados',
    'tickets.edit': 'Editar',
    'tickets.scan': 'Foto',
    'tickets.viewScan': 'Ver ticket escaneado',
    'tickets.noScan': 'Sin foto guardada',
    'tickets.delete': 'Borrar ticket',
    'tickets.markReviewed': 'Marcar revisado',
    'tickets.noRateAdd': 'Sin tarifa · Agregar',
    'tickets.noRateHelp': 'Este código no tiene tarifa para la fecha del ticket — se facturaría/pagaría a $0. Toque para agregar la tarifa.',
    'tickets.didYouMean': '¿Quiso decir {code}?',
    'tickets.noTruck': 'Sin camión',
    'tickets.createTruck': '+ Crear este camión',
    'tickets.rowsPerPage': 'Filas por página',
    'tickets.showing': 'Mostrando {from}–{to} de {total}',
    'tickets.pageOf': 'Página {page} de {pages}',
    'tickets.addTitle': 'Agregar ticket nuevo',
    'col.date': 'Fecha',
    'col.ticketNo': 'Ticket #',
    'col.customer': 'Cliente',
    'col.qty': 'Cant.',
    'col.truck': 'Camión',
    'col.lastUpdated': 'Última edición',
    'col.actions': 'Acciones',
    'status.printed': 'Impreso',
    'status.pending': 'Por revisar',
    'status.verified': 'Verificado',
    'status.error': 'Error',
    'status.needsFix': 'Por corregir',
    'status.incomplete': 'Incompleto',
    'status.needsRate': 'Sin tarifa',
    'field.ticketType': 'Tipo de ticket',
    'field.date': 'Fecha',
    'field.ticketNo': 'Núm. de ticket',
    'field.truckNo': 'Núm. de camión',
    'field.plant': 'Planta',
    'field.customer': 'Cliente',
    'field.tons': 'Toneladas',
    'field.jobCode': 'Código de trabajo',
    'field.truckType': 'Tipo de camión',
    'field.billedTo': 'Cliente (Facturar a)',
    'field.hours': 'Horas',
    'field.loads': 'Cargas',
    'field.origin': 'Productor / Origen (opcional)',
    'field.destination': 'Destino (opcional)',

    'inv.title': 'Facturación',
    'inv.docType': 'Tipo de documento',
    'inv.settlement': 'Hoja de liquidación',
    'inv.zone': 'Factura por zona',
    'inv.settlementHelp': 'Una fila por ticket en la hoja del despachador — lo que entrega para cobrar. Deje la plantilla en blanco para usar la hoja de cada despachador.',
    'inv.zoneHelp': 'Tickets agrupados por cliente y código FS a la tarifa de zona — lo que le cobra al cliente.',
    'inv.generate': 'Generar',
    'inv.preview': 'Vista previa',
    'inv.pdf': 'PDF',
    'inv.attachScans': 'Adjuntar tickets escaneados al PDF',
    'inv.invoice': 'FACTURA',
    'inv.number': 'NÚM. DE FACTURA',
    'inv.date': 'FECHA',
    'inv.orderFrom': 'PEDIDO DE',
    'inv.truck': 'CAMIÓN',
    'inv.week': 'SEMANA',
    'inv.dispatcher': 'DESPACHADOR',
    'inv.tickets': 'TICKETS',
    'inv.totalTickets': 'TOTAL DE TICKETS',
    'inv.gross': 'BRUTO',
    'inv.commission': 'COMISIÓN',
    'inv.fuel': 'COMBUSTIBLE',
    'inv.rent': 'RENTA',
    'inv.net': 'NETO',
    'inv.total': 'TOTAL',
    'inv.amountDue': 'MONTO A PAGAR',
    'inv.discount': 'DESCUENTO',
    'inv.subTotal': 'SUBTOTAL',
    'inv.grandTotal': 'GRAN TOTAL',
    'inv.blended': 'combinado',
    'inv.perTruck': '{n} facturas — una por camión',
    'inv.time': 'HORA',
    'inv.ticketNo': 'TICKET #',
    'inv.pickup': 'RECOGE',
    'inv.delivery': 'ENTREGA',
    'inv.jobCode': 'TRABAJO / CÓDIGO',
    'inv.qty': 'CANT.',
    'inv.quantity': 'CANTIDAD',
    'inv.rate': 'TARIFA',
    'inv.priceEach': 'PRECIO C/U',
    'inv.amount': 'IMPORTE',
    'inv.description': 'DESCRIPCIÓN',
    'inv.createTitle': 'Crear factura',
    'inv.createPdf': 'Crear PDF de factura',
    'inv.pickCompany': 'Elija un subcontratista (o un camión) y toque Buscar para crear la factura.',
    'inv.countSummary': '{inv} factura(s) · {tickets} ticket(s) en total',
    'inv.companyName': 'Empresa',
    'inv.address': 'Dirección',
    'inv.phone': 'Teléfono',
    'inv.customerName': 'Cliente',
    'inv.fsCode': 'Código FS',
    'inv.tonnage': 'Toneladas',
    'inv.truckNo': 'Camión #',
    'inv.totalTons': 'Toneladas totales',
    'inv.zoneRate': 'Tarifa de zona',
    'inv.less10': 'Menos 10%',
    'inv.finalTotal': 'Total final',
    'inv.settlementsTitle': 'Liquidaciones',
    'inv.invoiceNumber': 'Núm. de factura',
    'inv.invoiceDate': 'Fecha de factura',
    'inv.defaultsToEnd': 'Si se deja vacía, la fecha final',
    'inv.searchPlaceholder': 'Buscar…',
    'inv.allTrucks': 'Todos los camiones',
    'inv.noTrucksForSub': 'Este subcontratista no tiene camiones',
    'inv.noTrucks': 'Sin camiones',
    'inv.trucksHelpSub': 'Opcional; vacío = todos los camiones del subcontratista',
    'inv.trucksHelp': 'Opcional; vacío = todos los camiones',
    'inv.allPlants': 'Todas las plantas',
    'inv.plantsHelp': 'Opcional; vacío = todas las plantas',
    'inv.noDispatcher': 'Ninguno — hoja genérica',
    'inv.dispatchersHelpMulti': 'Cada ticket descuenta el %, renta y combustible de su despachador; el primero imprime la hoja',
    'inv.dispatchersHelp': 'Opcional; imprime en su hoja y descuenta su %, renta y combustible',
    'inv.template': 'Plantilla de factura',
    'inv.templatePlaceholder': 'Hoja del despachador',
    'inv.templateHelp': 'Opcional; cambia la hoja solo para esta impresión',
    'inv.weekNo': 'Semana #',
    'inv.weekNoHelp': 'Opcional; por defecto la semana ISO',
    'inv.weekStart': 'Inicio de semana',
    'inv.weekEnd': 'Fin de semana',
    'inv.discountPct': 'Descuento %',
    'inv.discountHelp': 'Opcional; p. ej. 5 para un descuento de 5%',

    'nav.billing': 'Pagos',

    'auth.google': 'Continuar con Google',
    'auth.googleFailed': 'No se pudo entrar con Google. Intente de nuevo.',
    'auth.googleDisabled': 'El acceso con Google aún no está activado. Use correo y contraseña.',
    'auth.or': 'o',
    'auth.email': 'Correo electrónico',
    'auth.password': 'Contraseña',
    'auth.passwordHelp': 'Mínimo 6 caracteres',
    'auth.signIn': 'Entrar',
    'auth.createAccount': 'Crear cuenta',
    'auth.signUpTitle': 'Empiece su prueba gratis',
    'auth.signUpSub': '14 días gratis. Sin tarjeta. Listo en 2 minutos desde su teléfono.',
    'auth.haveAccount': '¿Ya tiene cuenta?',
    'auth.trialLine': 'Escanee tickets, facture y pague a sus choferes — desde su teléfono.',
    'auth.errInUse': 'Ese correo ya tiene cuenta. Mejor entre.',
    'auth.errWeak': 'La contraseña debe tener al menos 6 caracteres.',
    'auth.errEmail': 'Escriba un correo válido.',
    'auth.errNetwork': 'Sin conexión. Revise su señal e intente de nuevo.',
    'auth.errSignUp': 'No se pudo crear la cuenta. Intente de nuevo.',
    'login.headline': 'Automatice la oficina de su empresa de transporte',
    'login.subhead': 'Escaneo de tickets, facturación, nómina y conciliación — todo en un lugar.',
    'login.feature1': 'Escaneo y lectura de tickets con IA',
    'login.feature2': 'Facturas para subcontratistas y plantas',
    'login.feature3': 'Nómina semanal de choferes por código FS',
    'login.feature4': 'Tarifas y conciliación',
    'login.title': 'Entre a su cuenta',
    'login.sub': 'Escriba sus datos para entrar.',
    'login.passwordPlaceholder': 'Escriba su contraseña',
    'login.forgot': '¿Olvidó su contraseña?',
    'login.signingIn': 'Entrando...',
    'login.agree': 'Al entrar acepta nuestros',
    'login.terms': 'Términos de servicio',
    'login.and': 'y',
    'login.privacy': 'Aviso de privacidad',
    'login.newHere': '¿Es nuevo? Empiece su prueba gratis',
    'login.emailRequired': 'Escriba su correo',
    'login.passwordRequired': 'Escriba su contraseña',
    'login.resetSent': 'Le enviamos un correo para cambiar su contraseña.',
    'login.errDisabled': 'Su cuenta fue desactivada. Hable con su administrador.',
    'login.errCredentials': 'Correo o contraseña incorrectos. Intente de nuevo.',
    'login.errGeneric': 'No se pudo entrar. Intente de nuevo.',

    'onb.stepOf': 'Paso {n} de {total}',
    'onb.welcome': '¡Bienvenido!',
    'onb.pickType': '¿Qué tipo de negocio tiene?',
    'onb.typeOO': 'Dueño-operador',
    'onb.typeOODesc': 'Tengo mi(s) camión(es) y acarreo para un despachador o planta',
    'onb.typeDispatcher': 'Despachador',
    'onb.typeDispatcherDesc': 'Despacho subcontratistas y facturo a plantas y clientes',
    'onb.typeDryVan': 'Flota de caja seca',
    'onb.typeDryVanDesc': 'Tengo camiones de caja seca y llevo cargas, pago de choferes y ganancias',
    'onb.trialNote': 'Prueba gratis de 14 días. Sin tarjeta.',
    'onb.aboutYou': 'Sobre su negocio',
    'onb.company': 'Nombre del negocio',
    'onb.companyFleet': 'Nombre de la flota / negocio',
    'onb.firstName': 'Su nombre',
    'onb.lastName': 'Su apellido (opcional)',
    'onb.signedInAs': 'Conectado como {email}',
    'onb.required': 'Obligatorio',
    'onb.back': 'Atrás',
    'onb.startTrial': 'Empezar prueba gratis',
    'onb.trucksTitle': 'Sus camiones',
    'onb.trucksHelp': 'Agregue cada camión, quién lo maneja y cuánto gana. Los tickets se asignan por número de camión.',
    'onb.trucksHelpDryVan': 'Agregue cada camión, quién lo maneja y su pago como % de la carga. Puede agregar más después.',
    'onb.truckN': 'Camión {n}',
    'onb.removeTruck': 'Quitar camión',
    'onb.truckNumber': 'Número de camión',
    'onb.driverName': 'Nombre del chofer (opcional)',
    'onb.driverHelp': 'Déjelo vacío si usted lo maneja',
    'onb.driverPay': 'Pago del chofer',
    'onb.driverPayHelp': '% de lo que gana el camión',
    'onb.addTruck': 'Agregar otro camión',
    'onb.continue': 'Continuar',
    'onb.skip': 'Saltar por ahora',
    'onb.needTruck': 'Agregue al menos un número de camión.',
    'onb.badPct': 'El pago del chofer debe estar entre 0 y 100%.',
    'onb.dupTruck': 'El mismo número de camión aparece dos veces.',
    'onb.ready': '¡Todo listo!',
    'onb.trialStarted': 'Su prueba gratis de 14 días ya empezó.',
    'onb.scanNow': 'Tome foto a un ticket ahora',
    'onb.scanHint': 'Ponga el ticket plano y con buena luz. Nosotros lo leemos.',
    'onb.later': 'Lo hago después',
    'onb.goTrucks': 'Ir a mis camiones',
    'onb.errNetwork': 'Sin conexión. Revise su señal e intente de nuevo.',
    'onb.errGeneric': 'Algo salió mal. Intente de nuevo.',

    'bill.title': 'Pagos',
    'bill.yourAccount': 'Su cuenta',
    'bill.stateActive': 'Activa',
    'bill.stateTrial': 'Prueba gratis',
    'bill.stateTrialEnded': 'Prueba terminada',
    'bill.statePastDue': 'Pago pendiente',
    'bill.stateReadOnly': 'Solo lectura',
    'bill.trialLeft': 'Le quedan {n} día(s) de prueba gratis (termina {date}).',
    'bill.graceLeft': 'Elija un plan en {n} día(s) para seguir agregando tickets. Sus datos están seguros.',
    'bill.readOnlyHelp': 'Puede ver todo, pero no agregar ni cambiar nada hasta activar un plan. No se borró nada.',
    'bill.plan': 'Plan',
    'bill.plans': 'Planes',
    'bill.perMonth': '/ mes',
    'bill.perWeek': '/ semana',
    'bill.usagePrice': '{ticket} por ticket, mínimo {min} {per}',
    'bill.upToTickets': 'hasta {n} tickets',
    'bill.upToTrucks': 'hasta {n} camiones',
    'bill.paymentsSoon': 'Pronto podrá pagar en línea (tarjeta, Apple Pay, Google Pay, banco). No necesita tarjeta durante la prueba.',
    'bill.samplePrices': 'Precios de ejemplo — pueden cambiar.',
    'bill.loadFailed': 'No se pudo cargar. Intente de nuevo.',
    'bill.bannerTrial': 'Prueba gratis: le quedan {n} día(s). Toque para ver planes.',
    'bill.bannerTrialEnded': 'Su prueba gratis terminó. Elija un plan en {n} día(s) para seguir agregando tickets.',
    'bill.bannerPastDue': 'Falló el pago. Actualícelo en {n} día(s) para seguir agregando tickets.',
    'bill.bannerReadOnly': 'Su cuenta está en solo lectura. Toque para elegir un plan — sus datos están seguros.',
};

const strings = { en, es };
export default strings;
